import { render, staticRenderFns } from "./detail_comment.vue?vue&type=template&id=ed57fb1c&"
import script from "./detail_comment.vue?vue&type=script&lang=js&"
export * from "./detail_comment.vue?vue&type=script&lang=js&"
import style0 from "./detail_comment.vue?vue&type=style&index=0&id=ed57fb1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports